module.exports = __webpack_public_path__ + "static/015.thumb-d32710f4b24107a91145717006895803.jpg";